import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { resumenCampos, esSerializado, nombreBusqueda } from './utils';

/**
 * Genera un PDF manifiesto de transferencia.
 * variante: 'envio'   → pick list (lista de items a enviar)
 *           'recepcion' → comprobante con cantidades recibidas y motivos
 */
export function imprimirManifiestoTransferencia(transferencia, variante = 'envio') {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const pageWidth = doc.internal.pageSize.getWidth();
  const nombreEmpresa = localStorage.getItem('nombre_compania') || 'Bankivo';
  const titulo = variante === 'recepcion' ? 'Comprobante de Recepción' : 'Manifiesto de Envío';

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(14);
  doc.text(nombreEmpresa, pageWidth / 2, 18, { align: 'center' });

  doc.setFontSize(11);
  doc.text(titulo, pageWidth / 2, 25, { align: 'center' });

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);

  // Bloque datos
  const leftX = 14;
  const rightX = pageWidth / 2 + 5;
  let y = 35;

  const row = (x, label, value) => {
    doc.setFont('helvetica', 'bold'); doc.text(label, x, y);
    doc.setFont('helvetica', 'normal'); doc.text(String(value ?? '—'), x + 30, y);
  };

  row(leftX, 'Código:', transferencia.codigo || '—');
  row(rightX, 'Estado:', transferencia.estado || '—');
  y += 6;
  row(leftX, 'Origen:', transferencia.almacen_origen_nombre || '—');
  row(rightX, 'Destino:', transferencia.almacen_destino_nombre || '—');
  y += 6;
  row(leftX, 'Transportista:', transferencia.transportista || '—');
  row(rightX, 'Fecha:', new Date().toLocaleDateString('es-DO'));
  y += 6;
  if (variante === 'envio') {
    row(leftX, 'Enviado por:', transferencia.enviado_por_nombre || transferencia.created_by_nombre || '—');
  } else {
    row(leftX, 'Recibido por:', transferencia.recibido_por_nombre || '—');
    row(rightX, 'F. recepción:', transferencia.fecha_recepcion ? new Date(transferencia.fecha_recepcion).toLocaleDateString('es-DO') : '—');
  }
  y += 8;

  if (transferencia.observaciones_envio) {
    doc.setFont('helvetica', 'bold'); doc.text('Observaciones de envío:', leftX, y); y += 4;
    doc.setFont('helvetica', 'normal');
    const lines = doc.splitTextToSize(transferencia.observaciones_envio, pageWidth - 28);
    doc.text(lines, leftX, y); y += lines.length * 4 + 2;
  }
  if (variante === 'recepcion' && transferencia.observaciones_recepcion) {
    doc.setFont('helvetica', 'bold'); doc.text('Observaciones de recepción:', leftX, y); y += 4;
    doc.setFont('helvetica', 'normal');
    const lines = doc.splitTextToSize(transferencia.observaciones_recepcion, pageWidth - 28);
    doc.text(lines, leftX, y); y += lines.length * 4 + 2;
  }

  // Tabla de items (incluye campos personalizados de la categoría, ej. chasis/serial).
  const items = transferencia.items || [];
  const headBase = ['Producto / Identificación', 'Categoría', 'Enviado'];
  const headRecep = variante === 'recepcion' ? ['Recibido', 'Motivo', 'Nota'] : [];

  const body = items.map(it => {
    const serial = esSerializado(it);
    const primary = serial
      ? (nombreBusqueda({ ...it, nombre: it.producto_nombre }) || it.producto_nombre || '—')
      : (it.producto_nombre || '—');
    const nombreSec = serial ? it.producto_nombre : null;
    const campos = resumenCampos(it, 3, serial ? ['id'] : []);
    const productoLabel = [primary, nombreSec, campos].filter(Boolean).join('\n');
    const base = [productoLabel, it.categoria_nombre || '—', String(it.cantidad_enviada || 0)];
    if (variante === 'recepcion') {
      return [
        ...base,
        it.rechazado ? 'RECHAZADO' : String(it.cantidad_recibida || 0),
        it.motivo_rechazo_codigo || '—',
        it.nota_item || '—',
      ];
    }
    return base;
  });

  autoTable(doc, {
    head: [[...headBase, ...headRecep]],
    body,
    startY: y + 2,
    margin: { left: 14, right: 14 },
    styles: { fontSize: 8, cellPadding: 2 },
    headStyles: { fillColor: [24, 88, 107], textColor: 255, fontStyle: 'bold' },
    alternateRowStyles: { fillColor: [245, 247, 250] },
  });

  let finalY = doc.lastAutoTable.finalY + 12;

  // Firmas
  if (variante === 'envio') {
    const mid = pageWidth / 2;
    doc.setDrawColor(180);
    doc.line(leftX, finalY + 12, leftX + 65, finalY + 12);
    doc.line(mid + 8, finalY + 12, mid + 73, finalY + 12);
    doc.setFont('helvetica', 'normal'); doc.setFontSize(8);
    doc.text('Firma quien entrega', leftX, finalY + 17);
    doc.text('Firma transportista', mid + 8, finalY + 17);
  } else {
    doc.setDrawColor(180);
    doc.line(leftX, finalY + 12, leftX + 65, finalY + 12);
    doc.setFontSize(8);
    doc.text('Firma quien recibe', leftX, finalY + 17);
  }

  const blob = doc.output('blob');
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank');
}
